import React from "react";
import { transformToHtml } from "../../../utils/CommonUtils";

export default function ScheduleBlock({
  scheduledInfo,
  actualOrExpectedInfo,
  isArrival = false,
}) {
  if (!scheduledInfo && !actualOrExpectedInfo) return null;

  return (
    <div
      className={`fsd-schedule-block ${isArrival ? "right" : ""} makeFlex gap16 ${
        isArrival ? "textRight" : ""
      }`}
    >
      {scheduledInfo && (
        <div>
          {scheduledInfo.title && (
            <div className="fontSize12">{transformToHtml(scheduledInfo.title)}</div>
          )}
          {scheduledInfo.text && (
            <div className="fontSize14 boldFont">{transformToHtml(scheduledInfo.text)}</div>
          )}
          {scheduledInfo.subtext && (
            <div className="fontSize14">{transformToHtml(scheduledInfo.subtext)}</div>
          )}
        </div>
      )}
      {actualOrExpectedInfo && (
        <div>
          {actualOrExpectedInfo.title && (
            <div className="fontSize12">{transformToHtml(actualOrExpectedInfo.title)}</div>
          )}
          {actualOrExpectedInfo.text && (
            <div className="fontSize22 blackFont">{transformToHtml(actualOrExpectedInfo.text)}</div>
          )}
          {actualOrExpectedInfo.subtext && (
            <div className="fontSize14 blackFont lh14">
              {transformToHtml(actualOrExpectedInfo.subtext)}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
